import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../../../atoms/Icon'

function NoData ({ message }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--dim-1)', gap: 'var(--dim-1)' }}>
      <Icon name='warning' />
      <p style={{ fontSize: 'var(--text-lg)' }}>{message}</p>
    </div>
  )
}

NoData.propTypes = {
  message: PropTypes.string
}

export default NoData
